<app-competition-item [title]="'Competition Logo'">
  <div class="content ml-4 mr-4 mb-2 pb-4">
    <div class="row">
      <div class="col-12 mb-1">
        <span class="title">Competition Logo*</span>
      </div>
    </div>
    <div class="row">
      <div class="col col-12 mb-3">
        <div class="logo-image" appImgDroppable (imgUrl)="onImgChange($event)" (click)="file.click()">
          <i class="icon icon-image" aria-hidden="true" *ngIf="!competition.logoUrl"></i>
          <div class="logo" *ngIf="competition.logoUrl" [style.background-image]="'url(' + competition.logoUrl + ')'"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-12 pr-1">
        <input inputFocus name="url" class="form-control border-0" type="text" [disabled]="true"
          [(ngModel)]="competition.logoFile" [attr.placeholder]="'Upload logo by clicking on the box above'" required>
      </div>
      <!-- <div class="col col-4 pl-1">
        <button type="button" class="btn border-0 blue" (click)="onUpload()" [disabled]="!competition.logoUrl">
          <span>UPLOAD</span>
        </button>
      </div> -->
      <input type="file" accept=".gif,.jpg,.jpeg,.png" #file (change)="onChange($event)" />
    </div>
    <div class="row">
      <div class="col col-12 mt-2 pr-1">
        <div class="note">Please ensure the image is in a PNG format with a transparent background and is a minimum size of 100x100px and maximum filesize below 400 KB</div>
      </div>
    </div>
  </div>
</app-competition-item>
